import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import MuiContext from './MuiComponentsContext';
import GoogleMapApiInitializator from './_GoogleMapApiInitializator';

function MuiComponentsProvider(_ref) {
  var children = _ref.children,
      googleApiKey = _ref.googleApiKey,
      linkComponent = _ref.linkComponent;

  var _useState = useState({
    fabVisible: false,
    googleApiKey: googleApiKey,
    linkComponent: linkComponent
  }),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var handleChangeSettings = React.useCallback(function () {
    var partial = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    setState(function (ps) {
      return _extends({}, ps, {}, partial);
    });
  }, []);
  var setFabVisible = React.useCallback(function (v) {
    return handleChangeSettings({
      fabVisible: v
    });
  }, [handleChangeSettings]);
  return React.createElement(MuiContext.Provider, {
    value: _extends({}, state, {
      updateSettings: handleChangeSettings,
      setFabVisible: setFabVisible
    })
  }, React.createElement(GoogleMapApiInitializator, {
    googleApiKey: googleApiKey
  }, children));
}

MuiComponentsProvider.propTypes = {
  children: PropTypes.node,
  googleApiKey: PropTypes.string,
  linkComponent: PropTypes.elementType
};
MuiComponentsProvider.defaultProps = {
  children: null,
  googleApiKey: undefined,
  linkComponent: 'a'
};
export default MuiComponentsProvider;